// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1808":"918b5d60931bfb7b1785","4101":"918b5d60931bfb7b1785","6745":"a3137b2a796b3f508346","9482":"6f7a773fdd62030c4fe1"}[chunkId] + ".css";
};